module.exports = __webpack_public_path__ + "static/media/3 kylo ren star wars george lucas lightsaber.1280x1707.2f932371.webp";